/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {completePreconditions} from '../api'

export const useMutationCompletePreconditions = createReactQueryMutationHook('completePreconditions', completePreconditions)
